import { jsx } from "react/jsx-runtime";
import { B as Box, c as ce } from "./Grid-CcQKdsgp.js";
const titleStyle = ce({
  variants: {
    sizeFont: {
      large: "[font-size:var(--fontSize-mobile-large-title)] md:[font-size:var(--fontSize-desktop-large-title)]",
      medium: "[font-size:var(--fontSize-mobile-medium-title)] md:[font-size:var(--fontSize-desktop-medium-title)]",
      small: "[font-size:var(--fontSize-mobile-small-title)] md:[font-size:var(--fontSize-desktop-small-title)]",
      xsmall: "[font-size:var(--fontSize-mobile-xsmall-title)] md:[font-size:var(--fontSize-desktop-xsmall-title)]"
    },
    sizeLineHeight: {
      large: "[line-height:var(--lineHeight-mobile-large-title)] md:[line-height:var(--lineHeight-desktop-large-title)]",
      medium: "[line-height:var(--lineHeight-mobile-medium-title)] md:[line-height:var(--lineHeight-desktop-medium-title)]",
      small: "[line-height:var(--lineHeight-mobile-small-title)] md:[line-height:var(--lineHeight-desktop-small-title)]",
      xsmall: "[line-height:var(--lineHeight-mobile-xsmall-title)] md:[line-height:var(--lineHeight-desktop-xsmall-title)]"
    }
  }
});
const Title = (props) => {
  var _a, _b, _c, _d, _e;
  const { as, size = "medium", md, d, className, children, weight } = props;
  const fontWeight = weight ? `mobile.${weight}` : void 0;
  const mdFontWeight = (md == null ? void 0 : md.weight) !== weight && (md == null ? void 0 : md.weight) ? `desktop.${md == null ? void 0 : md.weight}` : void 0;
  const dFontWeight = (d == null ? void 0 : d.weight) !== (md == null ? void 0 : md.weight) && (d == null ? void 0 : d.weight) !== weight && (d == null ? void 0 : d.weight) ? `desktop.${d.weight}` : void 0;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...props,
      as: as != null ? as : "p",
      d: {
        ...d,
        fontWeight: (_b = (_a = d == null ? void 0 : d.fontWeight) != null ? _a : md == null ? void 0 : md.fontWeight) != null ? _b : dFontWeight
      },
      md: {
        ...md,
        fontWeight: (_d = (_c = md == null ? void 0 : md.fontWeight) != null ? _c : props.fontWeight) != null ? _d : mdFontWeight
      },
      fontWeight: (_e = props.fontWeight) != null ? _e : fontWeight,
      className: `${titleStyle({
        sizeFont: props.fontSize ? void 0 : size,
        sizeLineHeight: props.lineHeight ? void 0 : size
      })} ${className != null ? className : ""}`,
      style: props.style,
      children
    }
  );
};
export {
  Title as T
};
